import { Scroll } from "@lib/scroll";
import { Pages } from "@lib/pages";
import { initConsent } from "@lib/consent";

// history.scrollRestoration = "manual";

class _App {
  private scroll = Scroll;
  pages = Pages;
  preferences!: {
    thirdParty: {
      necessary: boolean;
      functionality: boolean;
      analytics: boolean;
      marketing: boolean;
    };
    cmp: unknown;
  };

  constructor() {
    initConsent(this);
  }
}

export const App = new _App();
